import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { hasDeprecatedPath } from 'modules/reports/lib/fieldHelper'
import type { AbilityType } from 'modules/reports/store/models/types'

import AlertTooltip from './AlertTooltip'
import Info from './Info'
import InformationTooltip from './InformationTooltip'
import Options from './Options'
import { FieldType } from './types'

interface Props {
  fieldType: FieldType
  onRemoveField: (fieldType: FieldType) => void
  variables?: any[]
  types?: AbilityType[]
  /** True if the field can't be used with the current projection */
  fieldDisabled?: boolean
}

const Field = ({ fieldType, onRemoveField, variables, types, fieldDisabled = false }: Props) => {
  const { field, form } = fieldType
  const hasMissingField = !field || fieldDisabled
  const hasDeprecatedReference = field && hasDeprecatedPath(field)
  const filterAbility = 'filtering'
  const showInfoTooltip = types?.includes(filterAbility) && !form.isCompleted && !hasMissingField
  const showDialogTooltip = hasMissingField || hasDeprecatedReference
  const showOptions = !!types && field
  const label = !field ? fieldType.form.get('path').value : field.get('label')

  const onRemove = () => onRemoveField(fieldType)

  const dialogTooltipActive =
    showDialogTooltip !== undefined && showDialogTooltip && hasMissingField
  let optionElement = null

  if (showOptions && !dialogTooltipActive) {
    optionElement = (
      <Box cursor="pointer">
        <Options fieldType={fieldType} types={types} variables={variables as any} />
      </Box>
    )
  } else {
    optionElement = <AlertTooltip hasMissingField={hasMissingField} />
  }

  return (
    <Box
      borderRadius={{
        all: 'abs008',
      }}
      border={
        hasMissingField && {
          all: {
            width: 's2',
            style: 'solid',
            color: 'radicalRed1000',
          },
        }
      }
      background="grey200"
    >
      <Box padding="s8" flexDirection="row" alignItems="center" justifyContent="spaceBetween">
        <Box
          paddingLeft="s8"
          gap="s4"
          flexDirection="row"
          alignItems="center"
          style={{ wordBreak: 'break-word' }}
        >
          <Text.Normal weight="medium" size="200" color="grey1000">
            {label}
          </Text.Normal>
          {showInfoTooltip && (
            <InformationTooltip label={i18n.t('custom_reports.filter_not_configured')} />
          )}
        </Box>
        <Box flexDirection="row" alignItems="center" gap="s4">
          {optionElement}
          <Box cursor="pointer" onClick={onRemove}>
            <Icon.Medium icon="delete" color="grey600" />
          </Box>
        </Box>
      </Box>
      {showOptions && <Info fieldType={fieldType} types={types} />}
    </Box>
  )
}

export default observer(Field)
